import openErrorModal from "../Error/ErrorModal";
import User from "../Models/User";
import Roles from "../Constants/Roles";
import { createUser, fetchCreateUserModal } from "../HTTPRequests/UserRequests";
import UserBaseModal from "./UserBaseModal";
import Mediator from "../Utilities/Mediator";

export default class CreateUserModal extends UserBaseModal {

	constructor(createUserButton: HTMLButtonElement) {
		super(createUserButton);
	}

	public addCreateModalClickListener() {
		this.createUserBtn.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fecthCreateModal();
		}
	}

	private fecthCreateModal() {
		fetchCreateUserModal()
			.then((response: string) => {
				this.openCreateModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openCreateModal(modalHTMLString: string) {
		const modalDiv: HTMLDivElement = document.createElement("div");
		modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(modalDiv);
		this.addPhonenumberValidationMsg(modalDiv);

		const cancelButton: HTMLButtonElement = document.querySelector('#create-user-modal button');
		cancelButton.onclick = () => {
			modalDiv.remove();
		};

		const img: HTMLImageElement = document.querySelector('#create-user-modal img[alt="close icon"]');
		img.onclick = () => {
			modalDiv.remove();
		}

		const form: HTMLFormElement = document.querySelector("#user-modal");
		const selectRole: HTMLSelectElement = document.querySelector("#user-modal select");
		const selectStore = document.getElementById("select-store");
		selectRole.onchange = event => {
			this.changeStoresSelectVisibility(event, selectStore, form);
		}

		const saveButton: HTMLButtonElement = document.querySelector('#create-user-modal button:last-child');
		saveButton.onclick = () => {
			this.saveCreatedUser(modalDiv, form);
		}
	}

	private saveCreatedUser(modalDiv: HTMLDivElement, form: HTMLFormElement) {
		let { valid, data } = this.getModalData(form);
		form.onsubmit = ev => ev.preventDefault();

		if (valid) {
			document.body.append(this.loadingScreen);
			this.createUser(data, modalDiv);
		} else {
			form.reportValidity();
		}
	}

	private createUser(data: User, modalDiv: HTMLDivElement) {
		createUser(data)
			.then(() => {
				this.openSuccessMsgModal();
				modalDiv.remove();
				Mediator.emit("userCrudOperationFinished");
			}, (error) => { //backend error
				this.openErrorMsgModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openSuccessMsgModal() {
		const modal: HTMLDivElement = document.querySelector("#create-user-modal");
		let message: string = modal.dataset.msg;
		openErrorModal(message, "#AAC291", "  ", "30%", "165px");
	}

	private changeStoresSelectVisibility(event: Event, selectStore: HTMLElement, form: HTMLFormElement) {
		const modal: HTMLDivElement = document.querySelector("#create-user-modal .modal");
		if (event.target["value"] === Roles.DomainAdmin) {
			selectStore.remove();
			modal.style.height = "535px";
		} else {
			if (selectStore) {
				form.append(selectStore);
				modal.style.height = "640px";
			}
		}

		if (event.target["value"] === Roles.Admin
			|| event.target["value"] === Roles.DomainAdmin) {
			const emailInput: HTMLInputElement = document.querySelector('#user-modal input:last-of-type');
			emailInput.required = true;
		}
	}
}
